import { AppAutofocusDirective } from './app-autofocus.directive'
import { NgModule } from '@angular/core'

@NgModule({
    declarations: [AppAutofocusDirective],
    exports: [AppAutofocusDirective],
})
export class AppAutofocusModule {}
